import { createDefaultView } from '@vt/utils'
import { getApiVersion, http } from '../utils/domain'

// 获取视图设置
export const fetchViewConfig = ({ appId, tbId, vid, includeDefs }) => {
  if (!vid) {
    return Promise.resolve(createDefaultView(tbId))
  }
  let url = `${getApiVersion()}/apps/${appId}/tbs/${tbId}/views/${vid}`
  if (includeDefs) {
    url = `${url}?def=${includeDefs}`
  }
  return http().get(url).json()
}
